// extracted by mini-css-extract-plugin
module.exports = {"caseSolution":"style_caseSolution__ViXbm","caseSolution__title":"style_caseSolution__title__BjZDJ"};